import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('core-n20-dialog', {
    attrs: {
      "isOpen": _vm.internalOpen,
      "max-width": "800",
      "persistent": ""
    },
    on: {
      "close": _vm.cancel
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function () {
        return [_vm._v("\n    " + _vm._s(_vm.rule ? _vm.$i18n_t('Common.edit') : _vm.$i18n_t('Common.addNew')) + "\n    " + _vm._s(_vm.$i18n_t('Connectors.Monitoring.rules.title')) + "\n  ")];
      },
      proxy: true
    }, {
      key: "buttons",
      fn: function () {
        return [_c('core-button', {
          attrs: {
            "color": _vm.color,
            "prepend-icon": "fa-save",
            "disabled": !_vm.isValid
          },
          on: {
            "click": _vm.save
          }
        }, [_vm._v("\n      " + _vm._s(_vm.$i18n_t('Common.save')) + "\n    ")])];
      },
      proxy: true
    }])
  }, [_c('div', {
    staticClass: "pt-4"
  }, [_c(VTextField, {
    attrs: {
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "label": _vm.$i18n_t('Connectors.Monitoring.rules.fields.name'),
      "required": ""
    },
    model: {
      value: _vm.ruleData.name,
      callback: function ($$v) {
        _vm.$set(_vm.ruleData, "name", $$v);
      },
      expression: "ruleData.name"
    }
  }), _c(VSelect, {
    attrs: {
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "items": _vm.ruleTypes,
      "label": _vm.$i18n_t('Connectors.Monitoring.rules.fields.type'),
      "item-text": "text",
      "item-value": "value",
      "required": ""
    },
    on: {
      "change": _vm.onRuleTypeChange
    },
    model: {
      value: _vm.ruleData.ruleType,
      callback: function ($$v) {
        _vm.$set(_vm.ruleData, "ruleType", $$v);
      },
      expression: "ruleData.ruleType"
    }
  }), _c('p', {
    staticClass: "card-description mb-4"
  }, [_vm._v("\n      " + _vm._s(_vm.$i18n_t(`Connectors.Monitoring.rules.explanations.${_vm.ruleData.ruleType}`)) + "\n    ")]), _c(VSwitch, {
    staticClass: "mt-0 mb-2",
    attrs: {
      "color": _vm.color,
      "label": _vm.$i18n_t('Connectors.Monitoring.rules.fields.enabled')
    },
    model: {
      value: _vm.ruleData.enabled,
      callback: function ($$v) {
        _vm.$set(_vm.ruleData, "enabled", $$v);
      },
      expression: "ruleData.enabled"
    }
  }), _c(VDivider, {
    staticClass: "my-5"
  }), _c('h3', {
    staticClass: "mb-4"
  }, [_vm._v(_vm._s(_vm.$i18n_t('Connectors.Monitoring.rules.sections.conditions')))]), _vm.ruleData.ruleType === 'packet_threshold' ? [_c(VSelect, {
    attrs: {
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "items": _vm.operatorOptions,
      "label": _vm.$i18n_t('Connectors.Monitoring.rules.fields.operator'),
      "required": ""
    },
    model: {
      value: _vm.ruleData.conditions.operator,
      callback: function ($$v) {
        _vm.$set(_vm.ruleData.conditions, "operator", $$v);
      },
      expression: "ruleData.conditions.operator"
    }
  }), _c(VTextField, {
    attrs: {
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "label": _vm.$i18n_t('Connectors.Monitoring.rules.fields.packetThreshold'),
      "type": "number",
      "min": "0",
      "required": ""
    },
    model: {
      value: _vm.ruleData.conditions.threshold,
      callback: function ($$v) {
        _vm.$set(_vm.ruleData.conditions, "threshold", _vm._n($$v));
      },
      expression: "ruleData.conditions.threshold"
    }
  }), _c('time-input', {
    attrs: {
      "label": _vm.$i18n_t('Connectors.Monitoring.rules.fields.timeWindow')
    },
    model: {
      value: _vm.ruleData.conditions.timeWindow,
      callback: function ($$v) {
        _vm.$set(_vm.ruleData.conditions, "timeWindow", $$v);
      },
      expression: "ruleData.conditions.timeWindow"
    }
  })] : _vm._e(), _vm.ruleData.ruleType === 'state_duration' ? [_c(VSelect, {
    attrs: {
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "items": _vm.stateOptions,
      "label": _vm.$i18n_t('Connectors.Monitoring.rules.fields.targetState'),
      "item-text": "text",
      "item-value": "value",
      "required": ""
    },
    model: {
      value: _vm.ruleData.conditions.targetState,
      callback: function ($$v) {
        _vm.$set(_vm.ruleData.conditions, "targetState", _vm._n($$v));
      },
      expression: "ruleData.conditions.targetState"
    }
  }), _c(VSelect, {
    attrs: {
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "items": _vm.operatorOptions,
      "label": _vm.$i18n_t('Connectors.Monitoring.rules.fields.operator'),
      "required": ""
    },
    model: {
      value: _vm.ruleData.conditions.operator,
      callback: function ($$v) {
        _vm.$set(_vm.ruleData.conditions, "operator", $$v);
      },
      expression: "ruleData.conditions.operator"
    }
  }), _c('time-input', {
    attrs: {
      "label": _vm.$i18n_t('Connectors.Monitoring.rules.fields.durationThreshold')
    },
    model: {
      value: _vm.ruleData.conditions.threshold,
      callback: function ($$v) {
        _vm.$set(_vm.ruleData.conditions, "threshold", $$v);
      },
      expression: "ruleData.conditions.threshold"
    }
  }), _c('time-input', {
    attrs: {
      "label": _vm.$i18n_t('Connectors.Monitoring.rules.fields.evaluationWindow')
    },
    model: {
      value: _vm.ruleData.conditions.evaluationWindow,
      callback: function ($$v) {
        _vm.$set(_vm.ruleData.conditions, "evaluationWindow", $$v);
      },
      expression: "ruleData.conditions.evaluationWindow"
    }
  })] : _vm._e(), _vm.ruleData.ruleType === 'no_data' ? [_c('time-input', {
    attrs: {
      "label": _vm.$i18n_t('Connectors.Monitoring.rules.fields.silenceThreshold')
    },
    model: {
      value: _vm.ruleData.conditions.threshold,
      callback: function ($$v) {
        _vm.$set(_vm.ruleData.conditions, "threshold", $$v);
      },
      expression: "ruleData.conditions.threshold"
    }
  }), _c(VSwitch, {
    staticClass: "mt-2 mb-2",
    attrs: {
      "color": _vm.color,
      "label": _vm.$i18n_t('Connectors.Monitoring.rules.fields.requireActiveState')
    },
    model: {
      value: _vm.ruleData.conditions.requireActiveState,
      callback: function ($$v) {
        _vm.$set(_vm.ruleData.conditions, "requireActiveState", $$v);
      },
      expression: "ruleData.conditions.requireActiveState"
    }
  })] : _vm._e(), _vm.ruleData.ruleType === 'state_count' ? [_c(VSelect, {
    attrs: {
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "items": _vm.stateOptions,
      "label": _vm.$i18n_t('Connectors.Monitoring.rules.fields.targetState'),
      "item-text": "text",
      "item-value": "value",
      "required": ""
    },
    model: {
      value: _vm.ruleData.conditions.targetState,
      callback: function ($$v) {
        _vm.$set(_vm.ruleData.conditions, "targetState", _vm._n($$v));
      },
      expression: "ruleData.conditions.targetState"
    }
  }), _c(VSelect, {
    attrs: {
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "items": _vm.operatorOptions,
      "label": _vm.$i18n_t('Connectors.Monitoring.rules.fields.operator'),
      "required": ""
    },
    model: {
      value: _vm.ruleData.conditions.operator,
      callback: function ($$v) {
        _vm.$set(_vm.ruleData.conditions, "operator", $$v);
      },
      expression: "ruleData.conditions.operator"
    }
  }), _c(VTextField, {
    attrs: {
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "label": _vm.$i18n_t('Connectors.Monitoring.rules.fields.countThreshold'),
      "type": "number",
      "min": "1",
      "required": ""
    },
    model: {
      value: _vm.ruleData.conditions.threshold,
      callback: function ($$v) {
        _vm.$set(_vm.ruleData.conditions, "threshold", _vm._n($$v));
      },
      expression: "ruleData.conditions.threshold"
    }
  }), _c('time-input', {
    attrs: {
      "label": _vm.$i18n_t('Connectors.Monitoring.rules.fields.timeWindow')
    },
    model: {
      value: _vm.ruleData.conditions.timeWindow,
      callback: function ($$v) {
        _vm.$set(_vm.ruleData.conditions, "timeWindow", $$v);
      },
      expression: "ruleData.conditions.timeWindow"
    }
  })] : _vm._e(), _vm.ruleData.ruleType === 'state_change' ? [_c(VSelect, {
    attrs: {
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "items": _vm.stateOptionsWithAny,
      "label": _vm.$i18n_t('Connectors.Monitoring.rules.fields.targetState'),
      "item-text": "text",
      "item-value": "value",
      "required": ""
    },
    model: {
      value: _vm.ruleData.conditions.targetState,
      callback: function ($$v) {
        _vm.$set(_vm.ruleData.conditions, "targetState", _vm._n($$v));
      },
      expression: "ruleData.conditions.targetState"
    }
  }), _c(VSelect, {
    attrs: {
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "items": _vm.operatorOptions,
      "label": _vm.$i18n_t('Connectors.Monitoring.rules.fields.operator'),
      "required": ""
    },
    model: {
      value: _vm.ruleData.conditions.operator,
      callback: function ($$v) {
        _vm.$set(_vm.ruleData.conditions, "operator", $$v);
      },
      expression: "ruleData.conditions.operator"
    }
  }), _c(VTextField, {
    attrs: {
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "label": _vm.$i18n_t('Connectors.Monitoring.rules.fields.changeThreshold'),
      "type": "number",
      "min": "1",
      "required": ""
    },
    model: {
      value: _vm.ruleData.conditions.threshold,
      callback: function ($$v) {
        _vm.$set(_vm.ruleData.conditions, "threshold", _vm._n($$v));
      },
      expression: "ruleData.conditions.threshold"
    }
  }), _c('time-input', {
    attrs: {
      "label": _vm.$i18n_t('Connectors.Monitoring.rules.fields.timeWindow')
    },
    model: {
      value: _vm.ruleData.conditions.timeWindow,
      callback: function ($$v) {
        _vm.$set(_vm.ruleData.conditions, "timeWindow", $$v);
      },
      expression: "ruleData.conditions.timeWindow"
    }
  })] : _vm._e(), _vm.conditionSummary ? _c(VAlert, {
    staticClass: "mt-4 mb-0",
    attrs: {
      "color": _vm.color,
      "outlined": "",
      "dense": "",
      "icon": "fal fa-info-circle"
    }
  }, [_c('div', {
    staticClass: "text-body-2"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$i18n_t('Connectors.Monitoring.rules.summaries.configured')) + ":")]), _vm._v("\n        " + _vm._s(_vm.conditionSummary) + "\n      ")])]) : _vm._e(), _c(VDivider, {
    staticClass: "my-5"
  }), _c('h3', {
    staticClass: "mb-4"
  }, [_vm._v(_vm._s(_vm.$i18n_t('Connectors.Monitoring.rules.sections.behavior')))]), _c(VSelect, {
    attrs: {
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "items": _vm.severityOptions,
      "label": _vm.$i18n_t('Connectors.Monitoring.rules.fields.severity'),
      "required": ""
    },
    model: {
      value: _vm.ruleData.properties.severity,
      callback: function ($$v) {
        _vm.$set(_vm.ruleData.properties, "severity", $$v);
      },
      expression: "ruleData.properties.severity"
    }
  }), _c(VSwitch, {
    staticClass: "mt-2 mb-2",
    attrs: {
      "color": _vm.color,
      "label": _vm.$i18n_t('Connectors.Monitoring.rules.fields.autoResolve')
    },
    model: {
      value: _vm.ruleData.properties.autoResolve,
      callback: function ($$v) {
        _vm.$set(_vm.ruleData.properties, "autoResolve", $$v);
      },
      expression: "ruleData.properties.autoResolve"
    }
  }), _c('p', {
    staticClass: "card-description mt-0 mb-4"
  }, [_vm.ruleData.properties.autoResolve ? [_vm._v("\n        " + _vm._s(_vm.$i18n_t('Connectors.Monitoring.rules.explanations.autoResolveEnabled')) + "\n      ")] : [_vm._v("\n        " + _vm._s(_vm.$i18n_t('Connectors.Monitoring.rules.explanations.autoResolveDisabled')) + "\n      ")]], 2), _c('time-input', {
    attrs: {
      "label": _vm.$i18n_t('Connectors.Monitoring.rules.fields.cooldownPeriod')
    },
    model: {
      value: _vm.ruleData.properties.cooldownPeriod,
      callback: function ($$v) {
        _vm.$set(_vm.ruleData.properties, "cooldownPeriod", $$v);
      },
      expression: "ruleData.properties.cooldownPeriod"
    }
  }), _vm.behaviorSummary ? _c(VAlert, {
    staticClass: "mt-4 mb-0",
    attrs: {
      "color": _vm.color,
      "outlined": "",
      "dense": "",
      "icon": "fal fa-info-circle"
    }
  }, [_c('div', {
    staticClass: "text-body-2"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$i18n_t('Connectors.Monitoring.rules.summaries.behavior')) + ":")]), _vm._v("\n        " + _vm._s(_vm.behaviorSummary) + "\n      ")])]) : _vm._e(), _c(VDivider, {
    staticClass: "my-5"
  }), _c('h3', {
    staticClass: "mb-4"
  }, [_vm._v(_vm._s(_vm.$i18n_t('Connectors.Monitoring.rules.sections.notifications')))]), _c(VCheckbox, {
    staticClass: "mt-0 mb-2",
    attrs: {
      "color": _vm.color,
      "label": "Create AlarmLog Entry",
      "value": "alarmLog",
      "hide-details": ""
    },
    model: {
      value: _vm.ruleData.properties.notificationChannels,
      callback: function ($$v) {
        _vm.$set(_vm.ruleData.properties, "notificationChannels", $$v);
      },
      expression: "ruleData.properties.notificationChannels"
    }
  }), _c(VCheckbox, {
    staticClass: "mb-2",
    attrs: {
      "color": _vm.color,
      "label": _vm.emailLabel,
      "disabled": !_vm.hasEmailConnector,
      "value": "email",
      "hide-details": ""
    },
    model: {
      value: _vm.ruleData.properties.notificationChannels,
      callback: function ($$v) {
        _vm.$set(_vm.ruleData.properties, "notificationChannels", $$v);
      },
      expression: "ruleData.properties.notificationChannels"
    }
  }), false ? _c(VCheckbox, {
    staticClass: "mb-2",
    attrs: {
      "color": _vm.color,
      "label": _vm.webhookLabel,
      "disabled": !_vm.hasWebhookConnector,
      "value": "webhook",
      "hide-details": ""
    },
    model: {
      value: _vm.ruleData.properties.notificationChannels,
      callback: function ($$v) {
        _vm.$set(_vm.ruleData.properties, "notificationChannels", $$v);
      },
      expression: "ruleData.properties.notificationChannels"
    }
  }) : _vm._e()], 2)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };